var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"layers-filters":_vm.layersFilters,"is-custom-layer":true,"custom-layer-data":_vm.customLayerData}})}
var staticRenderFns = []

export { render, staticRenderFns }